const getTimeProperties = () => {
  try {
    return {
      timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
      locale: Intl.DateTimeFormat().resolvedOptions().locale,
    };
  } catch {
    return undefined;
  }
};

export const getErrorPropertiesForError = (error: unknown) => ({
  errorName: error instanceof Error ? error.name : 'Unknown',
  errorStack: error instanceof Error ? (error.stack?.substring(0, 300) ?? 'Unknown') : 'Unknown',
});

export const getBrowserContextData = (): Record<string, string> => {
  if (typeof window === 'undefined') {
    return {
      browserContextDataError: 'Window not defined during WebLogger initialization',
    };
  }

  try {
    const nav = window.navigator;
    const scr = window.screen;
    const loc = window.location;

    return {
      ...getTimeProperties(),
      userAgent: nav.userAgent,
      screenWidth: String(scr.width),
      screenHeight: String(scr.height),
      viewportInnerWidth: String(window.innerWidth),
      viewportInnerHeight: String(window.innerHeight),
      referrer: document.referrer,
      href: loc.href,
    };
  } catch (error) {
    const { errorName, errorStack } = getErrorPropertiesForError(error);
    return {
      browserContextDataErrorName: errorName,
      browserContextDataErrorStack: errorStack,
    };
  }
};
